import React from 'react'
import { Link } from 'react-router-dom'
import menu from '../assets/images/menu.png'
import close from '../assets/images/close.png'

export default function NavBar({display,setMenu}) {


  return (
    <div className='nav-bar'>
        <Link to='/' style={{color: '#fff', textDecoration: 'none'}}>
          <div className="logo">
              <span class="material-symbols-outlined">circle</span>
              <p>Badr Ib</p>
          </div>
        </Link>
        <p id='unique'>Portfolio</p>
        <button onClick={()=>{ setMenu(!display) }}>
            <img src={display ? close : menu} style={{width : display ? '20px' : '30px'}} />
        </button>
    </div>
  )
}
